import { useTranslations } from '@ms/yammer-i18n-react';
import LoginStrings from '@ms/yammer-strings/dist/Login';
import Block from '@ms/yammer-web-core-ui/dist/components/Block';
import Button from '@ms/yammer-web-core-ui/dist/components/Button';
import VerticalAlign from '@ms/yammer-web-core-ui/dist/components/VerticalAlign';
import React, { FC } from 'react';

export interface LoginProps {
  onClick(): void;
}

const Login: FC<LoginProps> = ({ onClick }) => {
  const t = useTranslations(LoginStrings);

  return (
    <Block paddingTop={20}>
      <VerticalAlign horizontalAlign="center">
        <Block textColor="accent" paddingBottom={7} textSize={900}>
          Viva Engage
        </Block>
        <Button className="qa-login-button" onClick={onClick} text={t.loginLabel()} color="primary" />
      </VerticalAlign>
    </Block>
  );
};

export default Login;
